import { Typography } from '@mui/material';

const sizes = {
    sm: '0.9375rem',
    md: '1.15rem',
    lg: '2.1rem',
};

export default function Price({ children, size = 'md', component = 'span', sx }) {
    return (
        <Typography
            component={component}
            sx={{
                fontFamily: 'DM Serif Display',
                fontVariantNumeric: 'tabular-nums',
                fontSize: sizes[size] || sizes.md,
                lineHeight: 1.1,
                color: 'text.primary',
                ...sx,
            }}
        >
            {children}
        </Typography>
    );
}
